import { Model } from "@/models/base/model";

export default class MyCalendar extends Model {
  private baseUrl = "/cms/api/my-report/calendar"; // ベースURL
  // コンストラクタ
  constructor(params: any = {}) {
    super(params);
    this.url = this.baseUrl;
  }

  // 月のデータ取得
  async getData(yearMonth: string, selectedDate: string): Promise<any> {
    this.url = `${this.baseUrl}?yearMonth=${yearMonth}&selectedDate=${selectedDate}`;
    return await super.fetch();
  }

  // 初回説明非表示設定
  async setCalendarHiddenFlag(): Promise<any> {
    this.url = `${this.baseUrl}/set-calendar-hidden-flag`;
    return await this.save({}, "PATCH");
  }
}
